module.exports = __webpack_public_path__ + "img/Recurso 23@300x.480c1859.png";